<template>
 <div class="dashboard bg-white">
   <div class="container-fluid">
     <sidebar />
     <latestMembers v-if="latestMember"/>
   </div>
 </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import sidebar from '@/components/_sidebar/sidebar'
import latestMembers from './components/latestMember'
export default {
  data () {
    return {
    }
  },
  created () {
    this.getLatestMember()
  },
  computed: {
    ...mapState('latestMember', ['latestMember'])
  },
  methods: {
    ...mapActions('latestMember', ['getLatestMember'])
  },
  components: {
    sidebar,
    latestMembers
  }
}
</script>
